import React, { useContext } from "react";
import PropTypes from "prop-types";
import { NavLink as RouteNavLink } from "react-router-dom";
import { NavItem, NavLink } from "shards-react";
import { SidebarContext } from "../../../providers/SidebarProvider";

const SidebarNavItem = ({ item }) => {
  const { toggleSidebar } = useContext(SidebarContext);  // Access toggleSidebar from context
  const handleNavLinkClick = () => {
    // Check if the screen width is less than or equal to 768px (mobile screen)
    if (window.matchMedia("(max-width: 768px)").matches) {
      toggleSidebar();
    }
  };
  return (
    <NavItem>
    <NavLink 
      tag={props => <RouteNavLink {...props} />} 
      to={item.to}
      onClick={handleNavLinkClick}  
    >
        {item.htmlBefore && (
          <div
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: item.htmlBefore }}
          />
        )}
        {item.title && <span>{item.title}</span>}
        {item.htmlAfter && (
          <div
            className="d-inline-block item-icon-wrapper"
            dangerouslySetInnerHTML={{ __html: item.htmlAfter }}
          />
        )}
      </NavLink>
    </NavItem>
  );
};

SidebarNavItem.propTypes = {
  /**
   * The item object.
   */
  item: PropTypes.object
};

export default SidebarNavItem;
